var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33572_63690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7401 4.61397C28.9152 4.7152 29.0555 4.86714 29.1424 5.04975C29.2294 5.23236 29.259 5.43705 29.2272 5.6368L24.8815 33.1528C24.8511 33.3452 24.7653 33.5246 24.6344 33.6689C24.5036 33.8132 24.3334 33.9161 24.1449 33.9651C23.9563 34.014 23.7576 34.0068 23.5731 33.9444C23.3886 33.8819 23.2263 33.7669 23.1062 33.6136L16.698 25.4615L6.43212 23.9821C6.23978 23.9541 6.05977 23.8707 5.91411 23.742C5.76846 23.6133 5.66346 23.4449 5.61196 23.2575C5.56047 23.0701 5.56471 22.8717 5.62416 22.6867C5.68362 22.5016 5.79571 22.3379 5.94674 22.2156L27.6107 4.70308C27.7677 4.57625 27.9595 4.49991 28.1607 4.4841C28.3619 4.46828 28.5652 4.51322 28.7401 4.61397Z",
    fill: "url(#paint0_linear_33572_63690)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33572_63690",
    x: -0.423828,
    y: 0.480957,
    width: 39.6641,
    height: 45.5161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33572_63690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33572_63690",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33572_63690",
    x1: 15.6865,
    y1: 7.80644,
    x2: 22.7872,
    y2: 34.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBAF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e12ea09e44cbf7170246c75ed38a655a.svg";
export { ForwardRef as ReactComponent };